"use client"

import { ReactNode, useRef } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

export function SetupClientProviders({ children }: { children: ReactNode }) {
    const queryClientRef = useRef<QueryClient | null>(null)
    if (!queryClientRef.current) {
        queryClientRef.current = new QueryClient()
    }
    return <QueryClientProvider client={queryClientRef.current}>{children}</QueryClientProvider>
}
